import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AppRoute } from '../config/route-config';
import { UserProvider } from '../context/user/UserProvider';
import { StoreProvider } from '../context/Store/StoreProvider';
import { UserFetcher } from '../components/UserFetcher/UserFetcher';
import { ReceivingPO } from '../components/ReceivingPO/ReceivingPO';
import { GlobalContextProvider } from '../context/global/GlobalContextProvider';
import { useSearchActions } from '../context/Search/SearchProvider';
import i18n from '../i18n';
import { CoworkerRequired } from '../api/user';
import { StoreConfigDetails } from '../types/types';

export const routesTestId = 'routesTestId';
/* eslint-disable sonarjs/cognitive-complexity */
const getCoWorkerDetails = async (
  setEnableMXPOReceivingValue: (value: string) => void,
  setSupportContactNumber: (value: string) => void,
  setOracleFusionEnableValue: (value: string) => void,
  setLocalSourceRampValue: (value: string) => void
) => {
  const storeNumber = String(window.sessionStorage.getItem('storeNumber'));
  const bodyobject = {
    storeNumbers: [String(window.sessionStorage.getItem('storeNumber'))],
    paramKeyNames: [
      'EnableMXPOReceiving',
      'SupportContactNumber',
      'OracleFusionEnable',
      'EnableLocalSourcing',
    ],
  };

  let configRes;

  if (
    storeNumber &&
    storeNumber != null &&
    storeNumber != undefined &&
    storeNumber != '' &&
    storeNumber != 'null' &&
    storeNumber != 'undefined'
  ) {
    configRes = await CoworkerRequired(bodyobject);
    if (configRes?.status === 200) {
      const MXPOReceivingConfigDetails =
        configRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails.find(
          (item: StoreConfigDetails) =>
            item.paramKeyName === 'EnableMXPOReceiving'
        );
      const SupportContactNumberConfigDetails =
        configRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails.find(
          (item: StoreConfigDetails) =>
            item.paramKeyName === 'SupportContactNumber'
        );
      const OracleFusionEnableConfigDetails =
        configRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails.find(
          (item: StoreConfigDetails) =>
            item.paramKeyName === 'OracleFusionEnable'
        );
      const LocalSourceRampConfigDetails =
        configRes?.data?.storeProfileResponse?.configDetails[0]?.configDetails.find(
          (item: StoreConfigDetails) =>
            item.paramKeyName === 'EnableLocalSourcing'
        );
      if (OracleFusionEnableConfigDetails) {
        setOracleFusionEnableValue(OracleFusionEnableConfigDetails?.paramValue);
      }
      if (SupportContactNumberConfigDetails) {
        setSupportContactNumber(SupportContactNumberConfigDetails?.paramValue);
      }
      if (MXPOReceivingConfigDetails) {
        setEnableMXPOReceivingValue(MXPOReceivingConfigDetails?.paramValue);
      }
      if (LocalSourceRampConfigDetails) {
        setLocalSourceRampValue(LocalSourceRampConfigDetails?.paramValue);
      }
    }
  }
};
/* eslint-disable sonarjs/cognitive-complexity */
export const Routes = () => {
  return (
    <UserProvider>
      {/* <PermissionsProvider> */}
      <UserFetcher />
      <StoreProvider>
        <GlobalContextProvider>
          {/* <SearchProvider> */}
          <ConfigLoader />
          <div data-testid={routesTestId}>
            <Switch>
              <Route exact path={AppRoute.Root}>
                <Redirect to={AppRoute.ReceivingPO} />
              </Route>
              <Route exact path={AppRoute.Index}>
                <Redirect to={AppRoute.ReceivingPO} />
              </Route>
              <Route exact path={AppRoute.ReceivingPO}>
                <ReceivingPO />
              </Route>
            </Switch>
          </div>
          {/* </SearchProvider> */}
        </GlobalContextProvider>
      </StoreProvider>
      {/* </PermissionsProvider> */}
    </UserProvider>
  );
};

const ConfigLoader = () => {
  const {
    setEnableMXPOReceivingValue,
    setSupportContactNumber,
    setOracleFusionEnableValue,
    setLocalSourceRampValue,
  } = useSearchActions();

  useEffect(() => {
    const language: any = window.sessionStorage.getItem('language');
    i18n.changeLanguage(language);
    getCoWorkerDetails(
      setEnableMXPOReceivingValue,
      setSupportContactNumber,
      setOracleFusionEnableValue,
      setLocalSourceRampValue
    );
  }, [
    setEnableMXPOReceivingValue,
    setSupportContactNumber,
    setOracleFusionEnableValue,
    setLocalSourceRampValue,
  ]);
  return null;
};
